import styled from 'styled-components';

const CardContainer = styled.div`
width: 100%;
display:flex;
gap:32px;
flex-wrap:wrap;
`;



const NoText = styled.div`
  color:  #BDBDBD;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  text-align: center;
`;

const PillarContent = styled.div`
  display: flex;
  height: 40px;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 40px;
  border: 0.75px solid #EFEFEF;

  /* Base background & text */
  background: ${({ disabled, selected }) =>
    disabled ? "#F2F2F2" : selected ? "#DA6C74" : "white"};

  color: ${({ disabled, selected }) =>
    disabled ? "#BDBDBD" : selected ? "white" : "#184A61"};

  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};

  transition: background 0.3s, color 0.3s, box-shadow 0.3s;

  /* Hover ONLY when not disabled and not selected */
  &:hover {
    background: ${({ disabled, selected }) =>
    disabled || selected ? undefined : "#DA6C74"};
    color: ${({ disabled, selected }) =>
    disabled || selected ? undefined : "white"};
    box-shadow: ${({ disabled, selected }) =>
    disabled || selected
      ? "none"
      : "0 6px 8px 0 rgba(227, 79, 149, 0.25)"};
  }

  /* Icon color handling */
  > img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
    filter: ${({ selected }) =>
    selected ? "brightness(0) invert(1)" : "none"};
  }

  &:hover > img {
    filter: ${({ disabled, selected }) =>
    disabled || selected
      ? "none"
      : "brightness(0) invert(1)"};
  }

  .listContent {
    font-family: "Lato";
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
  }
`;



const Heading = styled.div`
color: var(--Font-Color-on-Light-theme-500, #184A61);
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px; 
margin-top:20px;
margin-bottom:16px;
`;



export { CardContainer,NoText,PillarContent,Heading };
